<template>
    <div class="ls-swi">
        <span class="el-icon-check c-primary" v-if="code"></span>
        <span class="el-icon-close c-999" v-else></span>
    </div>
</template>
<script>
export default {
    props: {
        code: {
            default: 0
        }
    },
    data() {
        return {
        }
    },
    created() {
    },
    methods: {
    }
} 
</script>
<style lang="scss" scoped>
@import "index.scss";
</style>